export default __webpack_public_path__ + "static/media/direito-ambiental.717375fb.png";